import { render, staticRenderFns } from "./serviceOpenDialog.vue?vue&type=template&id=1ed16357&scoped=true&"
import script from "./serviceOpenDialog.vue?vue&type=script&lang=js&"
export * from "./serviceOpenDialog.vue?vue&type=script&lang=js&"
import style0 from "./serviceOpenDialog.vue?vue&type=style&index=0&id=1ed16357&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed16357",
  null
  
)

export default component.exports